import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MainLayout from "../components/layout/MainLayout";
import Breadcrumbs from "../components/common/Breadcrumbs";
import ExerciseScheduleList from "./../pages/ExerciseSchedule/ExerciseScheduleList";
import { fetchExerciseSchedules, deleteExerciseSchedule } from "../store/slices/exerciseSchedulesSlice";

const ExerciseSchedules = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // Get data from Redux store
    const { exerciseSchedules = [], isLoading, error } = useSelector((state) => state.exerciseSchedules);

    // Format records for display
    const formatRecords = (data) => {
        return data.map(item => ({
            id: item.id,
            clientName: item.client_name || "-",
            responsibleStaff: item.responsible_staff || "-",
            weight: item.weight || "-",
            goal: item.goal || "-",
            // Add other fields you might want to display
            bmi: item.bmi || "-",
            plan: item.plan || "-",
            effectiveDate: item.effective_date ? item.effective_date.split('T')[0] : "-",
            caseId: item.case_id || null,
            patientId: item.patient_id || null,
            // Include the full data for export
            rawData: item,
            // For backward compatibility with existing table columns
            client_name: item.client_name || "-",
            staff_name: item.responsible_staff || "-",
        }));
    };

    const [records, setRecords] = useState([]);

    // Fetch data on component mount
    useEffect(() => {
        dispatch(fetchExerciseSchedules());
    }, [dispatch]);

    // Update records when data changes
    useEffect(() => {
        if (exerciseSchedules.length > 0) {
            setRecords(formatRecords(exerciseSchedules));
        } else {
            setRecords([]);
        }
    }, [exerciseSchedules]);

    const handleAdd = () => navigate("/exercise-schedule/add");

    const handleEdit = (id) => {
        const record = records.find(r => r.id === id);
        if (record) {
            navigate(`/exercise-schedule/edit/${id}`, {
                state: {
                    caseId: record.caseId,
                    patientId: record.patientId
                }
            });
        } else {
            navigate(`/exercise-schedule/edit/${id}`);
        }
    };

    const handleDelete = async (id) => {
        try {
            await dispatch(deleteExerciseSchedule(id)).unwrap();
            // The record will be removed from Redux store automatically
            // No need to manually update local state
        } catch (error) {
            console.error("Failed to delete exercise schedule:", error);
        }
    };

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />

                {/* Show error if any */}
                {error && (
                    <div className="alert alert-danger alert-dismissible fade show" role="alert">
                        {error}
                        <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                    </div>
                )}

                <div className="card">
                    <h5 className="card-header text-center fw-bold">Exercise Schedules</h5>
                    <div className="card-body p-0">
                        <ExerciseScheduleList
                            records={records}
                            loading={isLoading}
                            onAdd={handleAdd}
                            onEdit={handleEdit}
                            onDelete={handleDelete}
                        />
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default ExerciseSchedules;